// src/App.js
import React from 'react';
import { getToken, getUser } from './utils/auth';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard';
import Navbar from './components/Navbar';
import SessionManager from './components/SessionManager';
import Usuarios from './pages/Usuarios/Usuarios';
import Vacaciones from './pages/Vacaciones/Vacaciones';
import PanelEmpleado from './pages/Vacaciones/PanelEmpleado';
import PanelReferente from './pages/Vacaciones/PanelReferente';
import PanelRH from './pages/Vacaciones/PanelRH';
import PanelAdmin from './pages/Vacaciones/PanelAdmin';
import ReportePorMes from './pages/Vacaciones/ReportePorMes';
import Recibos from './pages/Recibos/Recibos';
import GestionEmpresas from './pages/Recibos/GestionEmpresas';
import Legajo from './pages/Legajo/Legajo'; 
import ResetPassword from './pages/Login/ResetPassword';
import PreguntasIniciales from './pages/Login/PreguntasIniciales';
import RecuperarPassword from './pages/recuperaPassword';
import CambioPasswordObligatorio from './pages/CambioPasswordObligatorio';
import MiEquipo from './pages/MiEquipo';
import BienvenidaEmpleado from './pages/BienvenidaEmpleado';
import InstallPWA from './components/InstallPWA';
import MobileAppWrapper from './components/MobileAppWrapper';
import FullscreenMobile from './components/FullscreenMobile';
import './App.css';
import './styles/responsive.css';
import LegajoEmpleado from './pages/Legajo/LegajoEmpleado';
import LegajoAdmin from './pages/Legajo/LegajoAdmin';
import ErroresLog from './pages/ErroresLog';
import GestionPermisos from './pages/GestionPermisos';
import GestionPermisosNuevos from './pages/GestionPermisosNuevos';
import MonitoringDashboard from './pages/Admin/MonitoringDashboard';
import GestionEmailEmpresas from './pages/Admin/GestionEmailEmpresas';
import CMO from './pages/CMO/CMO';
import DashboardAusentismo from './pages/CMO/DashboardAusentismo';
import RequirePermiso from './components/RequirePermiso';



const AppLayout = () => {
  const location = useLocation();
  const token = getToken();
  const user = getUser();

  const showNavbar = token && location.pathname !== '/login';

  return (
    <MobileAppWrapper>
      {showNavbar && <Navbar />}
      {token && <SessionManager />}
      <div 
        style={{ 
          marginTop: showNavbar ? '70px' : '0',
          minHeight: showNavbar ? 'calc(100vh - 70px)' : '100vh',
          width: '100%',
          overflowX: 'hidden'
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              token ? (
                user?.rol === 'empleado' ? (
                  <Navigate to="/bienvenida" replace />
                ) : user?.rol === 'baja' ? (
                  <Navigate to="/recibos" replace />
                ) : (
                  <RequirePermiso checks={[{ modulo: 'dashboard', permiso: 'ver' }]} redirectTo="/bienvenida">
                    <Dashboard />
                  </RequirePermiso>
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route 
            path="/bienvenida"
            element={
              token ? <BienvenidaEmpleado /> : <Navigate to="/login" />
            }
          />
          <Route path="/usuarios" element={
            token ? (
              <RequirePermiso checks={[{ modulo: 'usuarios', permiso: 'ver' }]}>
                <Usuarios />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route path="/vacaciones" element={
            token ? (
              <RequirePermiso checks={[
                { modulo: 'vacaciones', permiso: 'ver_propias' },
                { modulo: 'vacaciones', permiso: 'ver' }
              ]}>
                <Vacaciones />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route path="/vacaciones/empleado" element={
            token && user?.rol === 'empleado' ? <PanelEmpleado /> : <Navigate to="/login" />
          } />
          <Route path="/vacaciones/referente" element={
            token && user?.rol && ['referente_vacaciones', 'referente', 'superadmin'].includes(user.rol) ? <PanelReferente /> : <Navigate to="/login" />
          } />
          <Route path="/vacaciones/rh" element={
            token && user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? <PanelRH /> : <Navigate to="/login" />
          } />
          <Route path="/vacaciones/admin" element={
            token && user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? <PanelAdmin /> : <Navigate to="/login" />
          } />
          <Route path="/vacaciones/reporte-mes" element={
            token && user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? <ReportePorMes /> : <Navigate to="/login" />
          } />
          <Route path="/recibos" element={
            token ? (
              <RequirePermiso checks={[
                { modulo: 'recibos', permiso: 'ver_propios' },
                { modulo: 'recibos', permiso: 'ver' }
              ]}>
                <Recibos />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route 
            path="/empresas" 
            element={
              token && user?.rol && ['admin', 'superadmin', 'admin_rrhh'].includes(user.rol) ? 
              <GestionEmpresas /> : 
              <Navigate to="/login" />
            } 
          />
          <Route
            path="/legajos"
            element={
              token ? (
                user?.rol === 'empleado' ? (
                  <RequirePermiso checks={[{ modulo: 'legajo', permiso: 'ver_propio' }]}>
                    <LegajoEmpleado />
                  </RequirePermiso>
                ) : user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? (
                  <RequirePermiso checks={[{ modulo: 'legajos', permiso: 'ver_todos' }]}>
                    <LegajoAdmin />
                  </RequirePermiso>
                ) : (
                  <RequirePermiso checks={[{ modulo: 'legajo', permiso: 'ver_propio' }]}>
                    <Legajo />
                  </RequirePermiso>
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/recuperar-password" element={<RecuperarPassword />} />
          <Route path="/cambio-password-obligatorio" element={<CambioPasswordObligatorio />} />
          <Route path="/preguntas-iniciales" element={<PreguntasIniciales />} />
          <Route path="/errores" element={
            token && user?.rol === 'superadmin' ? <ErroresLog /> : <Navigate to="/login" />
          } />
          <Route path="/permisos" element={
            token && user?.rol === 'superadmin' ? <GestionPermisos /> : <Navigate to="/login" />
          } />
          <Route path="/permisos/nuevos" element={
            token && user?.rol === 'superadmin' ? <GestionPermisosNuevos /> : <Navigate to="/login" />
          } />
          <Route path="/monitoring" element={
            token && user?.rol === 'superadmin' ? <MonitoringDashboard /> : <Navigate to="/login" />
          } />
          <Route path="/emails-empresas" element={
            token && user?.rol === 'superadmin' ? <GestionEmailEmpresas /> : <Navigate to="/login" />
          } />
          <Route path="/cmo" element={
            token && user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? (
              <RequirePermiso checks={[{ modulo: 'cmo', permiso: 'ver' }]}>
                <CMO />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route path="/cmo/ausentismo" element={
            token && user?.rol && ['admin_rrhh', 'superadmin'].includes(user.rol) ? (
              <RequirePermiso checks={[{ modulo: 'cmo', permiso: 'ver' }]}>
                <DashboardAusentismo />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route path="/mi-equipo" element={
            token && (user?.rol === 'referente' || user?.rol === 'superadmin') ? (
              <RequirePermiso checks={[
                { modulo: 'usuarios', permiso: 'ver_equipo' },
                { modulo: 'legajos', permiso: 'ver_equipo' },
                { modulo: 'recibos', permiso: 'ver_equipo' }
              ]}>
                <MiEquipo />
              </RequirePermiso>
            ) : <Navigate to="/login" />
          } />
          <Route 
            path="/" 
            element={
              token ? (
                user?.rol === 'empleado' ? 
                <Navigate to="/bienvenida" replace /> : 
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          <Route 
            path="*" 
            element={
              token ? (
                user?.rol === 'empleado' ? 
                <Navigate to="/bienvenida" replace /> : 
                <Navigate to="/dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
        </Routes>
      </div>
      <InstallPWA />
      <FullscreenMobile />
    </MobileAppWrapper>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
};

export default App;
